"use client";

import NextError from "next/error";

export default function GlobalError({
  error: _error,
}: {
  error: Error & { digest?: string };
}) {
  void _error;

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}